export default "__VITE_ASSET__74878bb4__"